// extracted by mini-css-extract-plugin
export default {"saveButton":"EditAssetsForm_saveButton__qihBJ","requried":"EditAssetsForm_requried__qyAzX","tabContent":"EditAssetsForm_tabContent__Qy4ve","active":"EditAssetsForm_active__7GmHU"};